import { takeLatest, call, select } from 'redux-saga/effects';
import { fetchFreshDeviations } from './actionCreators';
import { isApiError, request } from '../../../xhr';
import { getPrimaryTier, isDeviationAuthor } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const deviations = require('@wix/da-sample-data').deviationsByType.image;
        return {
            deviations: deviations.slice(0, 24)
        };
    }
}
function* fetchDeviations(deviationIds) {
    const result = yield call(request, {
        method: 'get',
        url: `/deviation/multifetch`,
        params: {
            deviationids: deviationIds.slice(0, 24)
        }
    }, fakeResponse);
    return result;
}
export function* doFetchFresh(action) {
    const { deviationIds , setEntityData  } = action.payload;
    const currentUser = yield select(getCurrentUser);
    const result = yield call(fetchDeviations, deviationIds);
    if (result && result.deviations && !isApiError(result)) {
        const deviations = result.deviations.map((deviation)=>{
            const isInTier = getPrimaryTier(deviation);
            const isOwner = isDeviationAuthor(deviation, currentUser);
            const { isPremium  } = normalizePremiumFolderData(deviation.premiumFolderData);
            const isForbidden = isPremium || isInTier && !isOwner;
            if (!isForbidden) {
                return deviation;
            }
            return undefined;
        }).filter((i)=>i !== undefined);
        if (deviations.length) {
            return setEntityData(deviations);
        }
    }
    setEntityData(undefined);
}
export default function* saga() {
    yield takeLatest(fetchFreshDeviations, doFetchFresh);
}
